import { Directive, ElementRef, output, HostListener, inject } from '@angular/core';

@Directive({ selector: '[fileSelect]' })
export class FileSelectDirective {
    fileSelected = output<File[]>();
    readonly _elRef = inject(ElementRef);

    @HostListener('change')
    onChange() {
        this.fileSelected.emit(this._elRef.nativeElement.files);
    }
}
